import { mobileModule } from '@/store/mobile/module'
import { upgradeModule } from '@/store/upgrade/module'

const openUpgradeModal = (upgradeContext?: {
    quizMode?: 'weakest' | 'missed'
    upgradePurchasePressed?: boolean
}) => {
    if (upgradeContext) {
        upgradeModule.state.upgradeContext = upgradeContext
    }
    upgradeModule.state.isShowingUpgradeModal = true
}

const closeUpgradeModal = () => {
    upgradeModule.state.isShowingUpgradeModal = false
    upgradeModule.state.upgradeContext = null

    // If user canceled upgrading after consuming upgrade-specific query params, clear them
    mobileModule.actions.clearUpgradeContextInheritedFromQueryParams()
}

export default {
    openUpgradeModal,
    closeUpgradeModal,
}
